import { Box, Grow, Alert, Button } from "@mui/material";
import React, { useState } from "react";

/** warns users that their changes won't be saved unless they download the pdf */
export const PDFDownloadDisclaimer = (): JSX.Element => {
  const [showDisclaimer, setShowDisclaimer] = useState<boolean>(true);

  const dismissAlertButKeepPersisting = () => {
    setShowDisclaimer(false);
    setTimeout(function () {
      setShowDisclaimer(true);
    }, 15000);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          zIndex: 11,
          position: "absolute",
          bottom: 15,
          maxWidth: "80%",
        }}
      >
        <Grow in={showDisclaimer}>
          <Alert
            severity="warning"
            color="info"
            elevation={1}
            action={
              <Button
                color="inherit"
                size="small"
                onClick={dismissAlertButKeepPersisting}
              >
                HIDE
              </Button>
            }
          >
            <Box component="span">
              {`Heads up: This form is provided in product as view-only. If you would like to edit and make changes, please download this form to your computer first, otherwise `}
              <strong>{`changes to this form will not be saved`}</strong>
              {` within product.`}
            </Box>
          </Alert>
        </Grow>
      </Box>
    </div>
  );
};
